import { FieldLabel } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { SimplePopup } from '@calendly/ui/components/popup';
import { SelectField } from '@calendly/ui/form/select-field';
import { TextField as RawTextField } from '@calendly/ui/form/text-field';
import { useState } from 'react';
import { getFeedbackOptions } from '../utils';
const textAreaResponseCss = "tngs8we";

/**
 * FeedbackPopup component
 * @param {Object} props - The component props
 * @param {Function} props.onConfirm - The function to call when the user confirms the feedback
 * @param {Function} props.onClose - The function to call when the user closes the popup
 * @returns {React.ReactNode} The FeedbackPopup component
 */
export const FeedbackPopup = ({
  onConfirm,
  onClose
}) => {
  const [selectedFeedbackId, setSelectedFeedbackId] = useState(null);
  const [feedbackDetails, setFeedbackDetails] = useState('');
  const submitFeedback = () => {
    const feedbackOptions = getFeedbackOptions();
    const selectedFeedback = feedbackOptions.find(option => option.id === selectedFeedbackId)?.name;
    onConfirm(selectedFeedback, feedbackDetails);
  };
  const onChangeFeedbackDetails = e => {
    setFeedbackDetails(e.target.value);
  };
  return <SimplePopup title={I18n.t('publisher.agent_hub.feedback_popup.title')} confirmLabel={I18n.t('publisher.agent_hub.feedback_popup.confirm_label')} cancelLabel={I18n.t('publisher.agent_hub.feedback_popup.cancel_label')} onConfirm={submitFeedback} onClose={onClose} eyebrowLabel={I18n.t('publisher.agent_hub.feedback_popup.eyebrow_label')}>
      <FlexLayout direction="column" gap="24">
        <div>
          <FieldLabel requiredMark="optional" text={I18n.t('publisher.agent_hub.feedback_popup.what_went_wrong')} />
          <SelectField options={getFeedbackOptions()} aria-label={I18n.t('publisher.agent_hub.feedback_popup.select_feedback')} placeholder={I18n.t('publisher.agent_hub.feedback_popup.select_feedback')} value={selectedFeedbackId} onChange={setSelectedFeedbackId} />
        </div>

        <div>
          <FieldLabel requiredMark="optional" text={I18n.t('publisher.agent_hub.feedback_popup.please_provide_details')} />
          <RawTextField type="textarea" placeholder={I18n.t('publisher.agent_hub.feedback_popup.what_was_unsatisfying')} aria-label={I18n.t('publisher.agent_hub.feedback_popup.what_was_unsatisfying')} rows="3" maxLength={2500} className={textAreaResponseCss} value={feedbackDetails} onChange={onChangeFeedbackDetails} />
        </div>
      </FlexLayout>
    </SimplePopup>;
};

require("./FeedbackPopup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FeedbackPopup.js");